<template>
    <div class="container-fluid">
        <h4 class="text-center">เพิ่มโปรโมชั่นโดยรายการสินค้าเดิม</h4>
        <br>
        <div class="row form-group">
            <div :class="col_label" class="text-right">
                <label>ชื่อโปรโมชั่น</label>
            </div>
            <div :class="col_input">
                <input type="text"
                       v-model="form.name"
                       class="form-control"/>
            </div>
        </div>
        <div class="row form-group">
            <div :class="col_label" class="text-right">
                <label>รายละเอียด</label>
            </div>
            <div :class="col_input">
                <input type="text"
                       v-model="form.description"
                       class="form-control"/>
            </div>
        </div>
        <div class="row form-group">
            <div :class="col_label" class="text-right">
                <label>เงื่อนไขโปรโมชั่น</label>
            </div>
            <div :class="col_input">
                <b-form-select :options="promotion"
                               v-model="form.condition">
                </b-form-select>
            </div>
        </div>
        <div class="row form-group">
            <div :class="col_label" class="text-right">
                <label>จำนวนขั้นต่ำ</label>
            </div>
            <div class="col-4">
                <input type="text" class="form-control" v-model="form.quantity"/>
            </div>
            <div class="col-3">
                <b-form-select :options="unit" v-model="form.unit_type">
                </b-form-select>
            </div>
        </div>
        <div class="row form-group">
            <div :class="col_label" class="text-right">
                <label>ส่วนลด</label>
            </div>
            <div class="col-4">
                <input type="text" class="form-control" v-model="form.discount"/>
            </div>
            <div class="col-3">
                <b-form-select :options="unit_price" v-model="form.discount_status_id">
                </b-form-select>
            </div>
        </div>
        <div class="col text-center">
            <button type="button" class="btn btn-success mr-2" @click="submitPromotion">
                <icon name="save"></icon>
                บันทึก
            </button>
            <button type="button" class="btn btn-outline-secondary" @click="cancelPromotion">
                <icon name="times"></icon>
                ยกเลิก
            </button>
        </div>
    </div>
</template>

<script>
    import { mapState } from "vuex";
    export default {
        name: "duplicate-promotion-modal",
        computed:{
            ...mapState({
                promotion:state=>{
                    return [
                        ...state.Promotion.condition.map(data => ({
                            value: data.id,
                            text: data.name
                        }))
                    ];
                },
            })
        },
        data(){
            return{
                col_label : "col-4",
                col_input : "col-6",
                unit_price:[
                    {value:1 , text:"฿"},
                    {value:2 , text:"%"},
                ],
                unit:[{
                    value:1 , text:"ลัง"
                }],
                form:{
                    name : "",
                    description : "",
                    status_id : 1,
                    condition : 1,
                    quantity : "",
                    unit_type : 1,
                    discount_status_id : 1,
                    discount : "",
                }

            }
        },
        methods:{
            submitPromotion(){
                this.$emit("submit",this.form);
                this.clearDataForm();
            },
            cancelPromotion(){
                this.$emit("submit",0);
                this.clearDataForm();
            },
            clearDataForm(){
                this.form = {
                    name : "",
                    description : "",
                    status_id : 1,
                    condition : 1,
                    quantity : "",
                    unit_type : 1,
                    discount_status_id : 1,
                    discount : "",
                }
            }
        }
    }
</script>

<style scoped>

</style>